// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"lesson-loader_titleContainer__7C-6O","contentContainer":"lesson-loader_contentContainer__S07xs","lectureTabContainer":"lesson-loader_lectureTabContainer__2uU6F"};